// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://obdggmcxrswxhpoozqcl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9iZGdnbWN4cnN3eGhwb296cWNsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA5NTk0OTUsImV4cCI6MjA1NjUzNTQ5NX0.T7F76eGha5g7INobt4_zT5n4X5OBQMoKjhlwSP5k4og";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Helper function to fetch user subscriptions
export const fetchSubscriptions = async () => {
  try {
    const response = await supabase
      .from('user_subscriptions')
      .select('id, user_id, plan_name, status, stripe_subscription_id, created_at, updated_at');
    
    return { data: response.data, error: response.error };
  } catch (error) {
    console.error('Error in fetchSubscriptions:', error);
    return { data: null, error: error as Error };
  }
};

// Helper function to fetch course enrollments that are used as subscriptions
export const fetchEnrollmentSubscriptions = async () => {
  try {
    const response = await supabase
      .from('course_enrollments')
      .select('id, user_id, email, course_id, payment_status, is_subscription, amount, created_at, updated_at, expires_at, enrollment_token, progress, completion_percentage')
      .eq('payment_status', 'completed')
      .eq('is_subscription', true);
    
    return { data: response.data, error: response.error };
  } catch (error) {
    console.error('Error in fetchEnrollmentSubscriptions:', error);
    return { data: null, error: error as Error };
  }
};

// Helper function to fetch payment links
export const fetchPaymentLink = async (productId: string) => {
  try {
    const response = await supabase
      .from('payment_links')
      .select('id, product_id, stripe_url, active, created_at')
      .eq('product_id', productId)
      .eq('active', true)
      .single();
    
    return { data: response.data, error: response.error };
  } catch (error) {
    console.error('Error in fetchPaymentLink:', error);
    return { data: null, error: error as Error };
  }
};